import { BasicButton } from "@/components";
import { ReferralSuccessSearchParamSchema } from "@/schemas";
import Box from "@mui/material/Box";
import { Link, createFileRoute } from "@tanstack/react-router";
import { zodSearchValidator } from "@tanstack/router-zod-adapter";

export const Route = createFileRoute("/dashboard/case/referrals/success")({
	validateSearch: zodSearchValidator(ReferralSuccessSearchParamSchema),
	component: RouteComponent,
});

function RouteComponent() {
	const cid = Route.useSearch({
		select: (s: ReferralSuccessSearchParamSchema) => s.cid,
	});
	const members = Route.useSearch({
		select: (s: ReferralSuccessSearchParamSchema) => s.members,
	});
	const ctitle = Route.useSearch({
		select: (s: ReferralSuccessSearchParamSchema) => s.ctitle,
	});
	const tags = Route.useSearch({
		select: (s: ReferralSuccessSearchParamSchema) => s.tags,
	});
	return (
		<>
			<div className="container wrapper h-full bg-success">
				<Box className="h-full flex flex-col justify-center items-center">
					<img
						src="/images/icon-success.svg"
						alt="icon-success"
						loading="lazy"
					/>
					<h1 className="text-xl font-semibold text-center px-9 mt-6 mb-4">
						External member invited successfully!
					</h1>
					<p className="text-sm text-gray-100 text-center mb-4">
						{members} has been notified about the {tags} request and will
						receive access to {ctitle} case details.
					</p>
					<div className="flex flex-col gap-4 justify-center items-center">
						<Link
							replace={true}
							to="/dashboard/case/view/$id"
							params={{ id: cid }}
						>
							<BasicButton
								variant="contained"
								color="secondary"
								className="!h-12 !text-sm !shadow-none"
							>
								View case details
							</BasicButton>
						</Link>
						<Link to={"/"}>
							<BasicButton
								variant="text"
								color="primary"
								className="!h-12 !text-sm !shadow-none"
							>
								back to home
							</BasicButton>
						</Link>
					</div>
				</Box>
			</div>
		</>
	);
}
